export function set<T>(array: Array<T>, index: number, element: T): T[] {
    return [...array.slice(0, index), element, ...array.slice(index + 1)];
}

export function remove<T>(array: Array<T>, index: number): T[] {
    return [...array.slice(0, index), ...array.slice(index + 1)];
}

export function insert<T>(array: Array<T>, index: number, element: T): T[] {
    return [...array.slice(0, index), element, ...array.slice(index)];
}

export function move<T>(array: Array<T>, fromIndex: number, toIndex: number): T[] {
    return insert(remove(array, fromIndex), toIndex, array[fromIndex]);
}
